// See https://stackoverflow.com/questions/34403269/what-is-the-best-way-to-deal-with-a-fetch-error-in-react-redux
export function errorMessage(state, action) {
  const { error } = action;

  // TODO: ActionTypes.RESOURCE_GET_ERROR
  if (error) {
    return {
      text: error,
    };
  }

  return {};
}
